import React, { Component } from 'react';
import axios from 'axios';
import logo from './go.svg';
import './App.css';
import { FullPComp } from './components/fullp'

function showNotification(message){
	var notification = document.querySelector('.mdl-js-snackbar');
	var data = {
	  message: message,
	  // actionHandler: function(event) {},
	  // actionText: 'Ok',
	  timeout: 3000
	};
	notification.MaterialSnackbar.showSnackbar(data);
}

function dialogInit(){
  // dialog stuff

  window.dialog = document.querySelector('dialog');
  if (! window.dialog.showModal) {
    window.dialogPolyfill.registerDialog(window.dialog );
  }
  
  window.dialog.querySelector('.hs-close-dialog-button').addEventListener('click', function() {
    window.dialog.close();
  });
  
  window.dialog.addEventListener('click', function (event) {
      var rect = window.dialog.getBoundingClientRect();
      var isInDialog=(rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
      if (!isInDialog) {
          window.dialog.close();
      }
  });
}

window.downloadRecaptchaCallback = function(response){
  window.downloadRecaptchaResponse = response;
  // console.log("recaptcha response: "+response);
}

window.downloadRecaptchaExpiredCallback = function(response){
  window.downloadRecaptchaResponse = null;
  window.downloaded = null;
  // console.log("recaptcha expired");
}

class App extends Component {
  
  constructor(props) {
    super(props);
    this.state = {purple: false,
                  currentPage: 'home',
                  currentTitle: 'Light Sync',
                  isLoading: false
    }
    
    setTimeout(dialogInit,100);
    this.dialogDownload = this.dialogDownload.bind(this);
  }
  
  pageChangeCallback(params){
    if(params.initialized && params.destination.index == 1){
      var currentTitle = 'Light Sync';
      switch(params.destination.index){
        case 0: currentTitle = 'Light Sync'; break;
        case 1: currentTitle = 'About'; break;
        case 2: currentTitle = 'Contact'; break;
      }
      this.setState({purple: true, currentPage: params.destination.anchor, currentTitle: currentTitle})
    } else {
      var currentTitle = 'Light Sync';
      switch(params.destination.index){
        case 0: currentTitle = 'Light Sync'; break;
        case 1: currentTitle = 'About'; break;
        case 2: currentTitle = 'Contact'; break;
      }
      this.setState({purple: false, currentPage: params.destination.anchor, currentTitle: currentTitle})
    }
  }
  
  dialogDownload(){
    if(window.downloadRecaptchaResponse && !window.downloaded){
      let downloadUrl = window.downloadUrl + '&recaptcha=' + window.downloadRecaptchaResponse;
      let that = this;
      that.setState({ isLoading: true });
      axios.get(downloadUrl)
            .then(function (response) {
              
                  console.log(response.data.downloadUrl);
                  window.location.assign(response.data.downloadUrl);
                  that.setState({ isLoading: false });
                  window.dialog.close();
                  window.downloaded = true;
                  // window.open(response.data.downloadUrl);
                  // showNotification("Thanks for downloading Experimental Hue Sync App.");
              })
              .catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                window.dialog.close();
                that.setState({ isLoading: false });
                showNotification("An error has occured. Please try again later.");
                // ...
              });
    } else if (window.downloaded) {
      showNotification("Downloads are limited in order to save bandwidth. Please try again in a couple of minutes. Thank you for understanding.");
    } else {
      showNotification("Please check recaptcha.");
    }
  }
  
  
  downloadApp(os) {
      let authUrl = 'https://us-central1-hue-sync.cloudfunctions.net/app/auth?recaptcha=' + os;
      let downloadUrl = 'https://us-central1-hue-sync.cloudfunctions.net/app/download?os=' + os;
      window.downloadUrl = downloadUrl;
     
      window.dialog.showModal();
  }
  
  render() {
    return (
      <div className="hs-app">
        <header className="hs-app-header layout-row layout-align-space-between-center layout-align-xs-left-center">
          <div className="layout-row">
            <div className={"hs-logo "+ (this.state.purple ? 'hs-purple-logo':'')} alt="logo" />
            <h1 className={"hs-app-title hide-xs "+ (this.state.purple ? 'hs-purple-text':'')}>Light Sync<span className="hs-beta-header">BETA</span></h1>
            <h1 className={"hs-app-title hide-gt-xs "+ (this.state.purple ? 'hs-purple-text':'')}>{this.state.currentTitle}</h1>
          </div>
          <div className="hide-xs"></div>
          <ul id="menu" className={"hide-xs "+ (this.state.purple ? 'hs-purple-text':'')}>
            <li data-menuanchor="home" className={this.state.currentPage == 'home' ? "active":''}><a href="#home">Home</a></li>
            <li data-menuanchor="about" className={this.state.currentPage == 'about' ? "active":''}><a href="#about">About</a></li>
            <li data-menuanchor="contact" className={this.state.currentPage == 'contact' ? "active":''}><a href="#contact">Contact</a></li>
          </ul>
        </header>
        <FullPComp pageChangeCallback={this.pageChangeCallback.bind(this)}></FullPComp>
        <div className={"layout-row layout-align-center-center hs-download-buttons "+ (this.state.currentPage == 'home' ? 'hs-download-buttons-visible':'')}>
      		  
              <a className="hs-download-button hide-xs" 
                 onClick={this.downloadApp.bind(this, 'linux')}>
                <i className="material-icons hs-download-icon hidden">file_download</i>Linux
              </a>
            
              <a className="hs-download-button hide-xs"
                onClick={this.downloadApp.bind(this, 'mac')}>
                <i className="material-icons hs-download-icon hidden">file_download</i>Mac
              </a>
            
              <a className="hs-download-button hide-xs"
                onClick={this.downloadApp.bind(this, 'windows')}>
                <i className="material-icons hs-download-icon hidden">file_download</i>Windows
              </a>
              
              <a className="hs-download-button" href="https://github.com/digital-concrete/light-sync" target="_blank">
                Github
              </a>
      		</div>
      		<div className={"hide-gt-xs hs-scroll-icon "+ (this.state.currentPage == 'home' ? 'hs-scroll-icon-visible':'')}>
      		  <a href="#about">
      		    <i className="material-icons">keyboard_arrow_down</i>
      		  </a>
      		</div>
        
        <div className={"mdl-tooltip mdl-tooltip--large "+ (this.state.currentPage != 'about' ? 'hidden':'')} for="hs-usage-1">
          Press the bridge button to initialise app on first run
        </div>
        <div className={"mdl-tooltip mdl-tooltip--large "+ (this.state.currentPage != 'about' ? 'hidden':'')} for="hs-usage-2">
          Update your preferences
        </div>
        <div className={"mdl-tooltip mdl-tooltip--large "+ (this.state.currentPage != 'about' ? 'hidden':'')} for="hs-usage-3">
          Enjoy!
        </div>
        
        <dialog class="mdl-dialog">
          <div class="mdl-dialog__content hs-download-dialog-content">
            <p>By downloading and using this application you agree with the terms and conditions of the <a href="https://github.com/digital-concrete/hue-ambiance/blob/master/LICENSE" target="_blank">MIT License</a> under which it is released.</p>
          </div>
          
          <div className="g-recaptcha" data-sitekey="6LekrHIUAAAAADo2x2Gx4U_S_o0UX2KNw1CmC-bP" 
                        data-callback="downloadRecaptchaCallback"
                        data-expired-callback="downloadRecaptchaExpiredCallback"
                        data-theme="dark"></div>
          <div class="mdl-dialog__actions layout-row hs-download-dialog-actions">
            <button type="button" class="mdl-button hs-close-dialog-button">Close</button>
            <button className={"mdl-button mdl-js-button mdl-button--raised mdl-button--colored hs-download-app-button "+ (this.state.isLoading == true ? 'hidden':'')} onClick={this.dialogDownload}>
              Download
            </button>
            <div className={"mdl-spinner mdl-spinner--single-color mdl-js-spinner hs-dialog-spinner is-active "+ (this.state.isLoading == false ? 'hidden':'')}></div>
          </div>
        </dialog>
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js